import { baseUrl } from "../config"

const singleFieldValidationRestUrl = baseUrl + "/rest/validate/field";
const emailValidationRestUrl = baseUrl + "/rest/validate/email";

async function fetchJSON(url: string, method: string, data: any) {
    const headers: HeadersInit = {
        "Content-Type": "application/json"
    }
    const response = await fetch(url, {
        method: method,
        headers: headers,
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        throw Error("wrong response to validation REST call to '" + method + " " + url + "'. Status: " + response.status)
    }
    return response.json();
}

type ValidateSingleInputFieldRequest = {
    type: string,
    value: string
}
type ValidationResult = {
    errorMessageId?: string
}

async function validateSingleInputField(request: ValidateSingleInputFieldRequest): Promise<ValidationResult> {
    return await fetchJSON(singleFieldValidationRestUrl, RequestMethod.post, request) as ValidationResult
}

type ValidateEmailFieldsRequest = {
    email: string,
    emailRepeat: string
}
type ValidateEmailFieldsResponse = {
    email?: ValidationResult
    emailRepeat?: ValidationResult
}

async function validateEmailFields(request: ValidateEmailFieldsRequest): Promise<ValidateEmailFieldsResponse> {
    return await fetchJSON(emailValidationRestUrl, RequestMethod.post, request) as ValidateEmailFieldsResponse
}

export {
    ValidationResult,
    ValidateSingleInputFieldRequest,
    validateSingleInputField,
    ValidateEmailFieldsResponse,
    ValidateEmailFieldsRequest,
    validateEmailFields
}

enum RequestMethod {
    post = "POST",
    get = "GET",
    delete = "DELETE",
    put = "PUT"
}
